import React from "react";
import InquiryToCustomer from "@/src/components/Serviceworld/InquiryToCustomer/InquiryToCustomer";
import LayoutProtectedRoutes from "@/src/containers/Layouts/LayoutProtectedRoutes";

export default function InquiryToCustomerPage() {
  return (
    <LayoutProtectedRoutes>
      <InquiryToCustomer />
    </LayoutProtectedRoutes>
  );
}
